<!--
  @Author: Yu Xiujie
  @Desc: 移动端的轮播图
  @Date: 2022-07-15
-->

<template>
  <div id="mSwipe">
    <div class="img_bigbox img_box" ref="boxHook">
      <div 
        class="service_banner"
        v-for="(item) in bannerArray" 
        :key="item.src"
      >
        <img class="bac-img" :src="item.src" alt="">
        <div class="titleName">{{ item.titleName }}</div>
        <img class='tip-img' src="static/mobile/index/img_home_hangye.png" alt=""/>
      </div>
    </div>
    <div class="left_btn" @click="moveLeftImg">
        <img src="static/mobile/index/icon_left.png" alt="">
      </div>
      <div class="rigth_btn" @click="moveRigthImg">
        <img src="static/mobile/index/icon_rigth.png" alt="">
      </div>
  </div>
  
</template>

<script>
import {BANNER_SERVICE,} from "../service/businessConsts";
export default {
  name: "mSwipe",
  data(){
    return{
      bannerArray: BANNER_SERVICE,
      timer: null,
    }
  },

  created(){
    // 轮播图
    this.timer = setInterval(()=>{
      this.moveRigthImg();
    },4000)
  },

  methods:{

    // 图片移动
    moveLeftImg(){     
      this.bannerArray.unshift(this.bannerArray[7])
      this.bannerArray.pop()
      let arr = this.bannerArray;
      this.bannerArray = []
      for(var i = 0;i < arr.length;i++){
        this.bannerArray[i] = arr[i]
      }  
    },

    moveRigthImg(){
      this.bannerArray.push(this.bannerArray[0])
      this.bannerArray.shift()
      let arr = this.bannerArray;
      this.bannerArray = []
      for(var i = 0;i < arr.length;i++){
        this.bannerArray[i] = arr[i]
      }    
    },
  },

  beforeDestroy(){
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

}
</script>

<style lang="scss" scoped>
#mSwipe{
  padding: 0;
  margin: 0;
}

.left_btn{
  position: absolute;
  top: 379px;
  left: 20px;
  width: 50px;
  height: 50px;
  background: #fff;
  box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.2);
  border-radius: 33px;
  img{
    width: 100%;
    height: 100%;
  }
}
    
.rigth_btn{
  position: absolute;
  top: 379px;
  // left: 680px;
  right: 20px;
  width: 50px;
  height: 50px;
  background: #fff;
  box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.2);
  border-radius: 33px;
  img{
    width: 100%;
    height: 100%;
  }
}



  .img_bigbox{
    margin: 0 auto;
    padding: 0;
    position: relative;
    width: 720px;
    height: 490px;
    overflow: hidden;
    .service_banner {
      position: relative;
      display: block;
      float: left;
      width: 144px;
      height: 490px;
      .bac-img{   
        width: 100%;
        height: 490px;
      }
      .titleName {
        position: absolute;
        top: 196px;
        left: 51px;
        width: 42px;
        height: 120px;
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 30px;
      }
      .tip-img{
        position: absolute;
        top: 331px;
        left: 67px;
        width: 10px;
        height: 53px;
      }
    }
  }


</style>


// WEBPACK FOOTER //
// src/components/mSwipe.vue